import { useState } from 'react'

function Accordian({ data } : any) {  
    const [showContent, setShowContent] = useState(false);
    const answers : any = data.answer

    return (
        <>
            <div className='expand-slide cursor-pointer py-5 mb-1 text-theme-black' onClick={() => setShowContent(!showContent)}>
                <div
                    className='select-none flex justify-between items-center' >
                    <p className='text-theme-dark-saffron text-md font-[500] lg:text-[20px] font-[400]'> { data.question } </p> 
                        <div>
                            {
                                showContent ?
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 p-1 bg rounded-full text-theme-dark-saffron" style={{ background : 'rgba(57, 20, 0, 0.2)' }}>
                                    <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                </svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 p-1 rounded-full text-theme-dark-saffron" style={{ background : 'rgba(57, 20, 0, 0.2)' }}>
                                    <path fillRule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clipRule="evenodd" />
                                </svg>
                            }
                        </div>
                </div>
                {
                    showContent && 
                    <p className='text-[16px] mt-3 text-[#313037] font-[300]' dangerouslySetInnerHTML={{'__html' : answers}} />
                }
            </div>
        </>
    )
}

Accordian.defaultProps = {
    data : {}
}

export default Accordian